import { render, staticRenderFns } from "./order_details.vue?vue&type=template&id=20207802&scoped=true"
import script from "./order_details.vue?vue&type=script&lang=js"
export * from "./order_details.vue?vue&type=script&lang=js"
import style0 from "./order_details.vue?vue&type=style&index=0&id=20207802&prod&lang=less"
import style1 from "./order_details.vue?vue&type=style&index=1&id=20207802&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "20207802",
  null
  
)

export default component.exports